import { createContext, useCallback, useContext, useState } from "react";
import QuoteDialog from "@/components/QuoteDialog";

const QuoteContext = createContext(null);

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState("");

  const openQuote = useCallback((productName = "") => {
    setProduct(productName);
    setOpen(true);
  }, []);

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
      <QuoteDialog open={open} onOpenChange={setOpen} defaultProduct={product} />
    </QuoteContext.Provider>
  );
};
